import gql from "graphql-tag";

export const stakedReputation = gql`
  fragment StakedReputation on StakedReputation {
    stakerId
    stakeeId
    stakedCredits
  }
`;
